const replaceCurrency = (input, currency) => input.replaceAll('€', currency).replaceAll('{currency}', currency);

export default replaceCurrency;
